import { LoaderFunctionArgs } from 'react-router';
import { mutate } from 'swr';
import AuthService from '../../features/authentication/AuthService';
import { Configuration } from '../../features/configuration/Configuration';

export type LoaderWithConfig<T = any> = (args: LoaderFunctionArgs, config: Configuration) => Promise<T> | T;

/**
 * Populate SWR cache with loader data.
 * Use this in loaders to make data immediately available to useSWR hooks.
 *
 * @param key - The SWR cache key (usually the API URL)
 * @param data - The data to cache
 */
export const primeSwrCache = <T>(key: string, data: T): void => {
    mutate(key, data, { revalidate: false });
};

export function withConfig<T>(loaderFn: LoaderWithConfig<T>, config: Configuration, authService?: AuthService) {
    return async (args: LoaderFunctionArgs) => {
        // Ensure user is authenticated before running loader
        if (authService) {
            const user = await authService.getUser();
            if (!user || user.expired) {
                // No valid session - trigger sign in
                authService.signinRedirect();
                // Return a promise that never resolves to prevent loader from continuing
                return new Promise(() => {});
            }
        }

        return loaderFn(args, config);
    };
}
